<div class="cmn-flex column">
    <app-recipients #recipientsComponent [needsAck]="true" [showGroupField]="true" [filterField]="true" [showIndividualField]="true"></app-recipients>
    <app-hourglass *ngIf="!ready() || loadingSomething"></app-hourglass>
    <mat-card class="cmn-flex spaced-top">
        <app-autocomplete #autoComplete
                          (selection)="selectTemplate($event)" (loadRequest)="load($event)" (autocompleteInput)="onTemplateChanged($event)"
                          [label]="'Change Template'" [hint]="'Search by ID, Name or Creator\'s Email'"
                          [objects]="autocompleteTemplates" [options]="autocompleteTemplatesFormatted" [doAutofocus]="false"
                          id="templateSelector"></app-autocomplete>

        <!-- Template Instructions (supports markdown) -->
        <div *ngIf="selectedTemplate?.instructions" class="cmn-flex column spaced-top-lg">
            <h2>Template Instructions</h2>
            <p id="instructionsPreview" [data]="selectedTemplate.instructions" markdown ngPreserveWhitespaces></p>
        </div>

        <div class="cmn-flex row space-between spaced-top-lg">
            <h2 id="template">{{selectedTemplate?.name || ""}} Template</h2>
            <button type="button" (click)="toggleEditing()" [class]="'is-editing-'+isEditingTemplate"
                    [disabled]="loadingSomething" color="primary" mat-button matTooltip="Edit Template">
                <div class="cmn-flex align-center gutters-sm">
                    <span>Edit</span>
                    <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                </div>
            </button>
        </div>
        <form #messageForm="ngForm">
            <div class="cmn-flex row gutters-lg">
                <div class="cmn-flex column flex-50 gutters flex">
                    <label>Message Input(s)</label>
                    <div *ngFor="let tag of tags; let i = index" [ngSwitch]="tag.input_type.toUpperCase()"
                         class="cmn-flex row">
                        <mat-form-field *ngSwitchCase="DROPDOWN" class="flex" matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}" id="{{tag.name}}">
                            <mat-select [(ngModel)]="tag.tag_text" (ngModelChange)="parseMessage()" [name]="tag.name + 'TagCtrl'" [required]="tag.required">
                                <mat-option *ngFor="let option of tag.tag_options.split(',')"
                                            [value]="option.trim()">{{option}}</mat-option>
                            </mat-select>
                            <mat-label>{{tag.prompt}}</mat-label>
                            <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                            <mat-error>Tag {{'{{' + tag.name + '\}\}'}} is required</mat-error>
                        </mat-form-field>
                        <div *ngSwitchCase="RADIO" matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                            <mat-label class="cmn-flex flex padded-bottom">{{tag.prompt}}<span *ngIf="tag.required">*</span></mat-label>
                            <mat-radio-group [(ngModel)]="tag.tag_text" #radioGroup="matRadioGroup" (ngModelChange)="parseMessage()"
                                             [name]="tag.name + 'TagCtrl'" [required]="tag.required">
                                <mat-radio-button class="cmn-flex gutters spaced-right" *ngFor="let option of tag.tag_options.split(',')"
                                                  [value]="option.trim()">{{option}}</mat-radio-button>
                            </mat-radio-group>
                            <mat-error class="custom-error" *ngIf="messageForm.submitted && radioGroup.value === ''">
                                Tag {{'{{' + tag.name + '\}\}'}} is required
                            </mat-error>
                        </div>
                        <mat-form-field *ngSwitchCase="TEXTBOX" class="flex" matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                            <input [(ngModel)]="tag.tag_text" (ngModelChange)="parseMessage()" [name]="tag.name + 'TagCtrl'"
                                   [required]="tag.required" matInput>
                            <mat-label>{{tag.prompt}}</mat-label>
                            <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                            <mat-error>Tag {{'{{' + tag.name + '\}\}'}} is required</mat-error>
                        </mat-form-field>
                        <app-date-time-picker *ngSwitchCase="DATE"
                                              class="flex"
                                              name="{{tag.name}}"
                                              required="{{tag.required}}"
                                              label="Choose a Date"
                                              [initialDate]="tag.tag_text"
                                              (dateChange)="dateChanged(tag, $event)">
                        </app-date-time-picker>
                        <mat-form-field *ngSwitchCase="APPLICATIONS" class="cmn-flex flex"
                                        matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                            <mat-chip-list [(ngModel)]="appList" #chipListApp [formControl]="appControl">
                                <mat-chip (removed)="removeApp(application)" *ngFor="let application of appList"
                                          [removable]="removable" [selectable]="selectable">
                                    {{application}}
                                    <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input [(ngModel)]="selectedAppName" #applicationInput
                                       (blur)="appFieldBlur($event, applicationInput)"
                                       (matChipInputTokenEnd)="addApp($event, applicationInput)"
                                       (ngModelChange)="applicationChange.next($event)"
                                       [matAutocomplete]="acApplication"
                                       [matChipInputFor]="chipListApp"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       name="appInputCtrl"
                                       id="applicationField" matInput>
                            </mat-chip-list>
                            <mat-hint>Please enter a ServiceNow application name</mat-hint>
                            <mat-error>Application name is required</mat-error>
                            <mat-placeholder>application<span *ngIf="tag.required">*</span></mat-placeholder>
                            <mat-autocomplete #acApplication="matAutocomplete"
                                              (optionSelected)="addApp($event.option.value, applicationInput)"
                                              [displayWith]="getAppName" id="appAutocomplete">
                                <mat-option *ngFor="let application of applications"
                                            [value]="application">
                                    {{application.application_name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field *ngSwitchCase="CLIENTS" class="cmn-flex flex"
                                        matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                            <mat-chip-list [(ngModel)]="clientsImpacted" #chipListClient [formControl]="clientControl">
                                <mat-chip (removed)="removeClient(client)" *ngFor="let client of clientsImpacted"
                                          [removable]="removable" [selectable]="selectable">
                                    {{client}}
                                    <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                                </mat-chip>
                                <input [(ngModel)]="currentClient" #clientInput
                                       (blur)="clientFieldBlur($event, clientInput)"
                                       (matChipInputTokenEnd)="addClient($event, clientInput)"
                                       (ngModelChange)="clientChange.next($event); parseMessage()"
                                       [matAutocomplete]="autoClient" [matChipInputFor]="chipListClient"
                                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                       id="clientField" matInput name="clientInputCtrl">
                            </mat-chip-list>
                            <mat-hint>Please enter a ServiceNow client name</mat-hint>
                            <mat-error>Client name is required</mat-error>
                            <mat-placeholder>client<span *ngIf="tag.required">*</span></mat-placeholder>
                            <mat-autocomplete #autoClient="matAutocomplete"
                                              (optionSelected)="addClient($event.option.value, clientInput)"
                                              [displayWith]="getClientName" id="clientAutocomplete">
                                <mat-option *ngFor="let client of clients"
                                            [value]="client">{{client.client_name}}</mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <mat-form-field *ngSwitchCase="SENTBY" class="cmn-flex flex">
                            <input [(ngModel)]="tag.tag_text"
                                   (ngModelChange)="senderChange.next($event); parseMessage()"
                                   [matAutocomplete]="acSender" name="sentCtrl" [required]="tag.required"
                                   matInput>
                            <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                            <mat-error>Tag {{'{{' + tag.name + '\}\}'}} is required</mat-error>
                            <mat-placeholder>Please enter an Individual's name</mat-placeholder>
                            <mat-autocomplete #acSender="matAutocomplete">
                                <mat-option *ngFor="let sender of senders" [value]="sender.full_name">
                                    {{sender.full_name}}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                        <div *ngSwitchCase="CONFIRM"
                             class="cmn-flex column space-around align-self-center align-center full-width margin-bottom"
                             matTooltip="Click to confirm you want to send message">
                            <mat-checkbox #confirm (ngModelChange)="parseMessage()" name="confirmCtrl"
                                          [ngModel]="confirmed" required>
                                Confirm you want to send the message
                            </mat-checkbox>
                            <mat-error *ngIf="messageForm.submitted && !confirm.checked"
                                       class="custom-error align-self-start">
                                Cannot send message until selected
                            </mat-error>
                        </div>
                        <mat-form-field *ngSwitchDefault class="flex" matTooltip="Tag {{'{{'+ tag.name+'\}\}'}}">
                            <textarea [(ngModel)]="tag.tag_text" (ngModelChange)="parseMessage()" [name]="tag.name + 'TagCtrl'"
                                      [required]="tag.required" matInput cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
                            <mat-placeholder>{{tag.prompt}}</mat-placeholder>
                            <mat-hint>Tag {{'{{' + tag.name + '\}\}'}}</mat-hint>
                            <mat-error>Tag {{'{{' + tag.name + '\}\}'}} is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="cmn-flex column flex-50 gutters">
                    <label [class]="'custom-disabled-' + isEditingTemplate">Template Preview</label>
                    <mat-form-field class="cmn-flex">
                        <textarea (ngModelChange)="parseMessage(); checkTemplateLength()"
                                  [(ngModel)]="templateMessage" [class]="'custom-disabled-' + isEditingTemplate"
                                  [name]="'messageCtrl'" [readonly]="isEditingTemplate"
                                  cdk-scrollable cdkAutosizeMaxRows="8" cdkAutosizeMinRows="2" cdkTextareaAutosize
                                  id="templatePreview" matInput maxlength="1000" minlength="4" required> </textarea>
                        <mat-hint>Enter input field {{'{tag(s)}'}} into the editor to include input values in your message.</mat-hint>
                        <mat-hint align="end" class="right">{{templateMessage.length || "0"}} / 1,000</mat-hint>
                        <mat-error *ngIf="!templateMessage.length">Please enter message text or select a template.</mat-error>
                    </mat-form-field>

                    <div class="cmn-flex column flex padded-top-lg">
                        <label class="dark-gray">Message Preview</label>
                        <span class="cmn-flex column" #messageCopy>
                            <app-copy-to-clipboard [data]="messageRequest.message" [targetEl]="messageCopy"></app-copy-to-clipboard>
                            <textarea [(ngModel)]="messagePreview" [name]="'messagePreviewCtrl'" class="custom-disabled-true"
                                      cdk-scrollable cdkAutosizeMaxRows="8" cdkAutosizeMinRows="2"
                                      cdkTextareaAutosize id="messagePreviewField" matInput readonly> </textarea>
                            <hr class="full-width">
                            <mat-hint align="end">{{messagePreview.length || "0"}} / {{getMaxMsgLength().toLocaleString("en-US")}}</mat-hint>
                        </span>

                        <p *ngIf="showTruncateError" class="cmn-error">Your message exceeds {{getMaxMsgLength().toLocaleString("en-US")}} characters and has been truncated</p>
                        <div class="cmn-flex row space-between spaced-top-md">
                            <app-spinner-button (buttonClick)="reset('Send Message Default')" [processing]="loadingSomething" type="button"
                                                buttonText="Cancel" matIcon="cancel" color="primary" id="cancelButton">
                            </app-spinner-button>
                            <app-spinner-button *ngIf="ready()" (buttonClick)="sendMessage()" type="submit" [disabled]="isInvalid()" matIcon="send"
                                                buttonText="Send" [processing]="saveDisabled || loadingSomething" color="primary" id="sendButton">
                            </app-spinner-button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </mat-card>
</div>
